import React from 'react'
import styled from 'styled-components'

import Item from './item'

import { SectionTexts } from './types'

type FaqSectionProps = SectionTexts

const FaqSection: React.FunctionComponent<FaqSectionProps> = ({ questions, title }) => {
    const items = questions.map((el, i) => <Item key={i} q={el.q} a={el.a} />)
    
    return (
        <>
            { title && title !== '' && <Title> {title} </Title>}
            { items }
        </>
    )
}

const Title = styled.h2`
    margin: 60px 0 16px 0;
    font-size: 24px;
    line-height: 32px;
`

export default FaqSection